import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { gameDetailsActions } from '../../store/gameDetailsSlice';
import { LuUser, LuFileText, LuDownload } from "react-icons/lu";
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { useLazyGetPotentialWinnersQuery } from '../../store/services/prizeServices';
import { useGetGameByIdQuery } from '../../store/services/gameServices';
import UsersModal from '../prizes/UsersModal';
import { formatGameReceiptTypes } from '../../utils/receiptFields';

const customStyles = {
    content: {
        position: 'static',
        borderRadius: '10px',
        padding: '0px',
        maxWidth: 'calc(100vw - 2rem)',
        overflow: 'hidden',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(2px)',          // Blur effect
        WebkitBackdropFilter: 'blur(2px)',   // Safari support
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
};

const GAME_TYPE_LABEL = {
    lottery: 'Lotari',
    cashback: 'Cashback',
    business_draw: 'Lotari për biznese',
};


const FISCAL_PARITY_LABEL = {
    all: 'Të gjithë',
    odd: 'Tek',
    even: 'Çift',
};

export const getGameStatus = (status) => {
    switch (status) {
        case "active":
            return <span>Aktive</span>;

        case "canceled":
            return <span>❌ E anuluar</span>;

        case "ended":
            return <span>E përfunduar</span>;

        default:
            return <span>Aktive</span>;
    }
};

Modal.setAppElement(document.getElementById('root'))

export default function GameDetails() {

    const gameFromStore = useSelector(state => state.game_details.data)
    const isOpen = useSelector(state => state.game_details.isOpen)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [isPotentialWinnersOpen, setIsPotentialWinnersOpen] = useState(false)
    const [fetchPotentialWinners, { data: potWinners }] = useLazyGetPotentialWinnersQuery()

    const { data: gameData, isLoading, error } = useGetGameByIdQuery(
        { id: gameFromStore?.game_id },
        { skip: !gameFromStore?.game_id }
    )

    const game = gameData?.data || gameFromStore

    const closeModal = () => {
        dispatch(gameDetailsActions.closeModal())
    }

    /* The file lives on the backend host, and browsers ignore `download` on cross-origin links
       (they open the PDF instead), so it's fetched as a blob and saved from a same-origin URL */
    const handleDownloadPDF = async (pdfPath) => {
        if (!pdfPath) return
        const url = `${process.env.REACT_APP_BACKEND_HOST}/api/${pdfPath}`
        try {
            const response = await fetch(url)
            if (!response.ok) throw new Error(`HTTP ${response.status}`)
            const blobUrl = URL.createObjectURL(await response.blob())
            const link = document.createElement('a')
            link.href = blobUrl
            link.download = (pdfPath.split('/').pop() || 'vendimi.pdf').replace(/^game_/, 'loja_')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
        } catch {
            window.open(url, '_blank')
        }
    }

    return (
        <div>
            {isPotentialWinnersOpen && (
                <UsersModal
                    isOpen={isPotentialWinnersOpen}
                    handleClose={() => setIsPotentialWinnersOpen(false)}
                    users={potWinners?.data || []}
                />
            )}
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className='max-h-[90dvh] overflow-y-auto'>
                    <div className="bg-white p-5 sm:p-8 w-[480px] max-w-full text-sm">
                        <div className='flex flex-col gap-4 items-center'>
                            <div className='flex flex-col gap-2 items-center'>
                                <div className='uppercase font-bold text-lg sm:text-xl pb-2 leading-3'>Detajet e lojës</div>
                            </div>
                            <hr className='w-full' />
                            {isLoading && (
                                <div className="flex justify-center items-center py-8">
                                    <div className="text-gray-500">Duke ngarkuar...</div>
                                </div>
                            )}
                            {error && (
                                <div className="flex justify-center items-center py-8">
                                    <div className="text-red-500">Gabim në ngarkim të të dhënave</div>
                                </div>
                            )}
                            {!isLoading && !error && game && (
                                <>

                                    <div className='flex flex-col gap-2 w-full text-sm'>
                                        <div className='flex justify-between items-center gap-4'>
                                            {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Titulli i lojës</div>
                                            <div className='text-xs font-medium text-right break-words min-w-0'>{game?.title}</div>
                                        </div>
                                        <div className='flex justify-between items-center gap-4'>
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Start Date</div>
                                            {/* <div><MdPhone color='var(--secondary-color)' size={24} /></div> */}
                                            <div className='text-xs font-medium text-right break-words min-w-0'>{new Date(game?.start_date).toLocaleDateString('en-GB')}</div>
                                        </div>
                                        <div className='flex justify-between items-center gap-4'>
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>End Date</div>
                                            {/* <div><MdEmail color='var(--secondary-color)' size={24} /></div> */}
                                            <div className='text-xs font-medium text-right break-words min-w-0'>{new Date(game?.end_date).toLocaleDateString('en-GB')}</div>
                                        </div>
                                        <div className='flex flex-col gap-2'>
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Përshkrimi</div>
                                            {/* <div><MdDateRange color='var(--secondary-color)' size={24} /></div> */}
                                            <div className='text-xs font-medium break-words whitespace-pre-wrap'>{game?.description}</div>
                                        </div>
                                        <div className='flex justify-between items-center gap-4'>
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Lloji</div>
                                            {/* <div><MdLocationPin color='var(--secondary-color)' size={24} /></div> */}
                                            <div className='text-xs font-medium text-right break-words min-w-0'>{GAME_TYPE_LABEL[game?.type] || game?.type}</div>
                                        </div>
                                        {game?.type === 'cashback' && (
                                            <div className='flex justify-between items-center gap-4'>
                                                <div className='text-xs uppercase text-gray-500 min-w-0'>Përqindja</div>
                                                {/* <div><MdLocationPin color='var(--secondary-color)' size={24} /></div> */}
                                                <div className='text-xs font-medium text-right break-words min-w-0'>{game?.cashback_percentage}%</div>
                                            </div>
                                        )}
                                        {(game?.type === 'business_draw' || (game?.type === 'lottery' && game?.business_prize_desc)) && (
                                            <>
                                                {Number(game?.business_prize_amount) > 0 && (
                                                    <div className='flex justify-between items-center gap-4'>
                                                        <div className='text-xs uppercase text-gray-500 min-w-0'>Shuma fituese</div>
                                                        <div className='text-xs font-medium text-right break-words min-w-0'>{game.business_prize_amount}€</div>
                                                    </div>
                                                )}
                                                <div className='flex flex-col gap-2'>
                                                    <div className='text-xs uppercase text-gray-500 min-w-0'>Përshkrimi i shpërblimit</div>
                                                    <div className='text-xs font-medium break-words whitespace-pre-wrap'>{game?.business_prize_desc || '—'}</div>
                                                </div>
                                                {/* Older games stored the business cap in `limit` */}
                                                <div className='flex justify-between items-center gap-4'>
                                                    <div className='text-xs uppercase text-gray-500 min-w-0'>Limiti i bizneseve fituese</div>
                                                    <div className='text-xs font-medium text-right break-words min-w-0'>
                                                        {game?.business_winners_limit > 0
                                                            ? game.business_winners_limit
                                                            : game?.limit > 0 ? game.limit : 'Pa limit'}
                                                    </div>
                                                </div>
                                                <div className='flex justify-between items-center gap-4'>
                                                    <div className='text-xs uppercase text-gray-500 min-w-0'>Përzgjedhja sipas</div>
                                                    <div className='text-xs font-medium text-right break-words min-w-0'>
                                                        {FISCAL_PARITY_LABEL[game?.fiscal_parity] || game?.fiscal_parity || '—'}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <div className='flex justify-between items-center gap-4'>
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Kuponat që pranohen</div>
                                            <div className='text-xs font-medium text-right break-words min-w-0'>
                                                {formatGameReceiptTypes(game?.receipt_type)}
                                            </div>
                                        </div>
                                        <div className={`flex ${game?.municipalities && game?.municipalities?.length > 0 ? 'flex-col' : 'flex-row'} gap-2 justify-between items-start`}>
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Komuna</div>
                                            {/* <div><IoMdCard color='var(--secondary-color)' size={24} /></div> */}
                                            <div className="text-xs font-medium break-words">
                                                {game?.municipalities?.length > 0
                                                    ? game.municipalities.map((municipality) => (
                                                        <div key={municipality.municipality_id}>• {municipality.municipality_name}</div>
                                                    ))
                                                    : "Të gjitha"}
                                            </div>
                                        </div>
                                        <div className={`flex ${game?.activities && game?.activities?.length > 0 ? 'flex-col' : 'flex-row'} gap-2 justify-between`}>
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Aktivitetet</div>
                                            {/* <div><IoMdCard color='var(--secondary-color)' size={24} /></div> */}
                                            <div className="text-xs font-medium break-words">
                                                {game?.activities?.length > 0
                                                    ? game.activities.map((activity) => (
                                                        <div key={activity.activity_id}>• {activity.activity_name}</div>
                                                    ))
                                                    : "Të gjitha"}
                                            </div>
                                        </div>
                                    </div>
                                    {game.tiers && game.tiers.length > 0 && (
                                        game.tiers.map(tier => (
                                            <div className='flex flex-col gap-2 w-full text-sm'>
                                                <hr />
                                                <div className='uppercase font-bold text-sm leading-3 text-center py-1'>Kushti {tier.tier_level} i lojës</div>
                                                <hr />
                                                <div className='flex justify-between items-center gap-4'>
                                                    {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                                    <div className='text-xs uppercase text-gray-500 min-w-0'>Numri minimal i kuponave</div>
                                                    <div className='text-xs font-medium text-right break-words min-w-0'>{tier?.required_receipts}</div>
                                                </div>
                                                {tier?.required_amount && (
                                                    <div className='flex justify-between items-center gap-4'>
                                                        {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                                        <div className='text-xs uppercase text-gray-500 min-w-0'>Shuma minimale e totalit të kuponave</div>
                                                        <div className='text-xs font-medium text-right break-words min-w-0'>{tier?.required_amount}€</div>
                                                    </div>
                                                )}
                                                <div className='flex justify-between items-center gap-4'>
                                                    {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                                    <div className='text-xs uppercase text-gray-500 min-w-0'>Shuma fituese</div>
                                                    <div className='text-xs font-medium text-right break-words min-w-0'>{tier?.prize_amount}€</div>
                                                </div>
                                                <div className='flex justify-between items-center gap-4'>
                                                    <div className='text-xs uppercase text-gray-500 min-w-0'>Numri i fituesve</div>
                                                    <div className='text-xs font-medium text-right break-words min-w-0'>{tier?.limit ?? '—'}</div>
                                                </div>
                                                {game?.status === 'active' && (
                                                    <div className='font-semibold underline text-blue-600 py-2 uppercase rounded-lg text-xs cursor-pointer' onClick={async () => {
                                                        setIsPotentialWinnersOpen(true)
                                                        const response = await fetchPotentialWinners({
                                                            type: game?.type,
                                                            game_id: game?.game_id,
                                                            tier_level: tier?.tier_level,
                                                            // ...(selectedMunicipalities.length > 0 ? { municipalities_no: selectedMunicipalities.map(mun => mun.value) } : {}),
                                                        }).unwrap()
                                                    }}>
                                                        Shiko fituesit potencial
                                                    </div>
                                                )}
                                                {game?.status === 'ended' && (
                                                    <div className='rounded-lg w-full pt-1 font-semibold underline text-blue-600 cursor-pointer uppercase text-xs'
                                                        onClick={() => {
                                                            closeModal()
                                                            navigate(`/reports?category=winners&type=${game?.type}&game_id=${game?.game_id}&tier_level=${tier?.tier_level}`)
                                                        }}
                                                    >
                                                        Lista e fituesve të kushtit {tier?.tier_level}
                                                    </div>
                                                )}
                                                {game?.status === 'ended' && (
                                                    <div className='rounded-lg w-full pt-1 font-semibold underline text-blue-600 cursor-pointer uppercase text-xs'
                                                        onClick={async () => {
                                                            setIsPotentialWinnersOpen(true)
                                                            const response = await fetchPotentialWinners({
                                                                type: game?.type,
                                                                game_id: game?.game_id,
                                                                tier_level: tier?.tier_level
                                                            }).unwrap()
                                                        }}
                                                    >
                                                        Lista e pjesëmarrësve tjerë të kushtit {tier?.tier_level}
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    )}
                                    {game?.status === 'ended' && game?.type === 'cashback' && (
                                        <div className='rounded-lg w-full pt-1 font-semibold underline text-blue-600 cursor-pointer uppercase text-xs'
                                            onClick={() => {
                                                closeModal()
                                                navigate(`/reports?category=winners&type=${game?.type}&game_id=${game?.game_id}`)
                                            }}
                                        >
                                            Lista e fituesve
                                        </div>
                                    )}
                                    {game?.status === 'ended' && game?.type === 'cashback' && (
                                        <div className='rounded-lg w-full pt-1 font-semibold underline text-blue-600 cursor-pointer uppercase text-xs'
                                            onClick={async () => {
                                                setIsPotentialWinnersOpen(true)
                                                const response = await fetchPotentialWinners({
                                                    type: game?.type,
                                                    game_id: game?.game_id,
                                                }).unwrap()
                                            }}
                                        >
                                            Lista e pjesëmarrësve tjerë
                                        </div>
                                    )}
                                    <div className='flex flex-col gap-2 w-full text-sm'>
                                        <hr />
                                        <div className='uppercase font-bold text-sm leading-3 text-center py-1'>Informata shtesë</div>
                                        <hr />
                                        <div className='flex justify-between items-center gap-4'>
                                            {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Statusi</div>
                                            <div className='text-xs font-medium text-right break-words min-w-0'>{getGameStatus(game?.status)}</div>
                                        </div>
                                        {game?.status === 'canceled' && (
                                            <div className='flex justify-between items-start gap-4'>
                                                {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                                <div className='text-xs uppercase text-gray-500 min-w-0'>Arsyeja e anulimit</div>
                                                <div className='text-xs font-medium w-1/2 text-right break-words'>{game?.cancel_reason}</div>
                                            </div>
                                        )}
                                        {game?.canceler_name && (
                                            <div className='flex justify-between items-center gap-4'>
                                                {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                                <div className='text-xs uppercase text-gray-500 min-w-0'>Anuluar nga</div>
                                                <div className='text-xs font-medium text-right break-words min-w-0'>{game?.canceler_name}</div>
                                            </div>
                                        )}
                                        {game?.cancel_decision_file && (
                                            <div className='flex justify-between items-center gap-4'>
                                                <div className='text-xs uppercase text-gray-500 min-w-0'>Vendimi i anulimit</div>
                                                <div
                                                    className='flex items-center gap-2 shrink-0 text-xs font-medium text-blue-600 cursor-pointer hover:text-blue-800'
                                                    onClick={() => handleDownloadPDF(game.cancel_decision_file)}
                                                >
                                                    <LuFileText size={14} />
                                                    <span>Shkarko</span>
                                                    <LuDownload size={12} />
                                                </div>
                                            </div>
                                        )}
                                        <div className='flex justify-between items-center gap-4'>
                                            {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Data e krijimit</div>
                                            <div className='text-xs font-medium text-right break-words min-w-0'>{game?.created_at}</div>
                                        </div>
                                        <div className='flex justify-between items-center gap-4'>
                                            {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Numri i protokollit</div>
                                            <div className='text-xs font-medium text-right break-words min-w-0'>{game?.protocol_number}</div>
                                        </div>
                                        {game?.file_path && (
                                            <div className='flex justify-between items-center gap-4'>
                                                <div className='text-xs uppercase text-gray-500 min-w-0'>Vendimi nga DP</div>
                                                <div
                                                    className='flex items-center gap-2 shrink-0 text-xs font-medium text-blue-600 cursor-pointer hover:text-blue-800'
                                                    onClick={() => handleDownloadPDF(game.file_path)}
                                                >
                                                    <LuFileText size={14} />
                                                    <span>Shkarko</span>
                                                    <LuDownload size={12} />
                                                </div>
                                            </div>
                                        )}
                                        <div className='flex justify-between items-center gap-4'>
                                            {/* <div><FaRegIdCard color='var(--secondary-color)' size={24} /></div> */}
                                            <div className='text-xs uppercase text-gray-500 min-w-0'>Krijuar nga</div>
                                            <div className='text-xs font-medium text-right break-words min-w-0'>{game?.creator_name}</div>
                                        </div>
                                    </div>
                                    {game?.status === 'active' && game?.type === 'cashback' && (
                                        <div className='font-semibold self-start underline text-blue-600 py-2 uppercase rounded-lg text-xs cursor-pointer' onClick={async () => {
                                            setIsPotentialWinnersOpen(true)
                                            const response = await fetchPotentialWinners({
                                                type: game?.type,
                                                game_id: game?.game_id,
                                            }).unwrap()
                                        }}>
                                            Shiko fituesit potencial
                                        </div>
                                    )}
                                    {game?.status === 'active' && (
                                        <div className='flex sticky bottom-0 flex-col bg-white py-4 sm:p-6 text-center text-white cursor-pointer gap-2 w-full text-sm' onClick={() => {
                                            dispatch(gameDetailsActions.closeModal())
                                            navigate(`/prizes?game_id=${game?.game_id}`)
                                        }}>
                                            <span className='p-2 bg-primary rounded-lg'>Gjenero fituesit</span>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>
        </div>)
}